import { gql } from '@apollo/client';

import { lessonPrintablesFragment } from './sections/lesson-printables/lesson-printables.graphql';
import { lessonVocabularyFragment } from './sections/vocabulary/vocabulary.graphql';
import { lessonStimulusFragment } from './sections/stimulus/stimulus.graphql';
import { lessonOutcomesFragment } from './sections/outcomes/outcomes.graphql';
import { lessonTeachingLearningSequenceFragment } from './sections/teaching-learning-sequence/teaching-learning-sequence.graphql';
import { lessonDetailsFragment } from './sections/details/details.graphql';
import { lessonWorksheetFragment } from './sections/lesson-worksheets/lesson-worksheets.graphql';
import {
  lessonHeroImageFragment,
  lessonLandscapeImageFragment,
  lessonSquareImageFragment,
} from './sections/images/hero-image.graphql';
import { completionFragment } from 'approot/planner/manage/planner.graphql';
import { lessonTextualConceptsFragment } from './sections/textual-concepts/textual-concepts.graphql';
import { lessonBigIdeasFragment } from './sections/big-ideas/big-ideas.graphql';
import { lessonNswAlignmentFragment } from './sections/nsw-alignment/nsw-alignment.graphql';
import { materialsFragment } from 'approot/shared/graphql/lesson/lesson.graphql';
import { lessonAssignFragment } from 'approot/shared/assign/assign-lesson.graphql';

export const lessonQuestionFragment = gql`
  fragment LessonQuestionFragment on Lesson {
    id
    notesJson
    focusQuestion {
      value
    }
    phenomena {
      value
    }
  }
`;

// Note: if you change the query name: GetLessonById
// also update in apollo.tsx RETRY_OPERATIONS
export const GET_LESSON_DETAILS = gql`
  query GetLessonById($input: GetLessonByIdInput!) {
    getLessonById(input: $input) {
      ...LessonWorksheetFragment
      ...LessonAssignFragment
      ...LessonDetailsFragment
      ...LessonHeroImageFragment
      ...LessonLandscapeImageFragment
      ...LessonSquareImageFragment
      ...LessonVocabularyFragment
      ...LessonStimulusFragment
      ...LessonOutcomesFragment
      ...LessonPrintablesFragment
      ...LessonTeachingLearningSequenceFragment
      ...LessonQuestionFragment
      ...LessonTextualConceptsFragment
      ...LessonBigIdeasFragment
      ...LessonNswAlignmentFragment
      slug
      canManageCurrentContent
      isAnnotated
      completion {
        ...Completion
      }
      materials {
        ...MaterialsFragment
      }
      lessonActivitiesSummary {
        coreActivities
        deeperActivities
        challengingActivities
        supportActivities
        stimulus
      }
      languagesSupported
      archivedAt
      lessonActivities {
        id
        language
        status
        version
      }
    }
  }
  ${lessonWorksheetFragment}
  ${lessonAssignFragment}
  ${lessonDetailsFragment}
  ${lessonPrintablesFragment}
  ${lessonHeroImageFragment}
  ${lessonLandscapeImageFragment}
  ${lessonSquareImageFragment}
  ${lessonVocabularyFragment}
  ${lessonStimulusFragment}
  ${lessonOutcomesFragment}
  ${lessonTeachingLearningSequenceFragment}
  ${completionFragment}
  ${lessonQuestionFragment}
  ${lessonTextualConceptsFragment}
  ${lessonBigIdeasFragment}
  ${lessonNswAlignmentFragment}
  ${materialsFragment}
`;

export const UPDATE_LESSON_BOOKMARKS = gql`
  mutation UpdateLessonBookmark($input: UpdateLessonBookmarkInput!) {
    updateLessonBookmark(input: $input) {
      id
      isAssigned
      assignedData {
        workSheetPages
        vocabularyEnPages
        vocabularyEsPages
        stimulusResourceIds
        activitiesBookmarks {
          version
          sectionIds
        }
      }
    }
  }
`;
